import React, { PropsWithChildren } from 'react';
import { Button, CircularProgress, Grid, TextField } from '@material-ui/core';
import { IIntegrationHealthcheckDTO } from '../../../app/domain/ICommunity';
import { ThirdPartyType } from '../../../models/ThirdPartyType';

export type EntrataCreds = {
  property_id: string;
  username: string;
  password: string;
  url: string;
};

export function EntrataForm({
  username,
  password,
  url,
  property_id,
  onChange,
  onIntegrationHealthcheck,
}: PropsWithChildren<
  {
    onChange: (data: Partial<EntrataCreds>) => void;
    onIntegrationHealthcheck?: (data: IIntegrationHealthcheckDTO) => Promise<void>;
  } & EntrataCreds
>): JSX.Element {
  const [isHealthcheckLoading, setIsHealthcheckLoading] = React.useState<boolean>(false);

  const onIntegrationHealthcheckHandle = () => {
    if (!onIntegrationHealthcheck) return;
    setIsHealthcheckLoading(true);
    const data: IIntegrationHealthcheckDTO = {
      type: ThirdPartyType.Entrata,
      data: {
        url,
      },
    };
    onIntegrationHealthcheck(data).finally(() => setIsHealthcheckLoading(false));
  };

  return (
    <>
      <Grid item md={6} xs={6}>
        <TextField
          fullWidth
          label="URL"
          onChange={({ target }) => onChange({ url: target.value })}
          value={url}
          variant="outlined"
          required
        />
      </Grid>
      <Grid item md={6} xs={6}>
        <TextField
          fullWidth
          label="Username"
          onChange={({ target }) => onChange({ username: target.value })}
          value={username}
          variant="outlined"
          required
        />
      </Grid>
      <Grid item md={6} xs={6}>
        <TextField
          fullWidth
          label="Password"
          onChange={({ target }) => onChange({ password: target.value })}
          value={password}
          variant="outlined"
          required
        />
      </Grid>
      <Grid item md={6} xs={6}>
        <TextField
          fullWidth
          label="Property ID"
          onChange={({ target }) => onChange({ property_id: target.value })}
          value={property_id}
          variant="outlined"
          required
        />
      </Grid>
      <Grid item md={3} xs={3}>
        <Button
          variant={'contained'}
          color="primary"
          disabled={!url || isHealthcheckLoading}
          onClick={onIntegrationHealthcheckHandle}
        >
          {'Integration check'}
          {isHealthcheckLoading && <CircularProgress size={24} style={{ marginLeft: '16px' }} />}
        </Button>
      </Grid>
    </>
  );
}
